"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResourceCard = void 0;
const react_1 = __importDefault(require("react"));
require("./ResourceCard.scss");
const package_1 = require("../../package");
const HCard_1 = __importDefault(require("../atoms/HCard"));
const Resource_1 = require("../../shapes/Resource");
const react_2 = require("@tolgee/react");
exports.ResourceCard = (0, package_1.linkedComponent)(Resource_1.Resource.request((resource) => ({
    resourceName: resource.name,
    resourceDescription: resource.description,
    resourceImage: resource.image,
    resourceId: resource.identifier,
})), ({ linkedData, onClick }) => {
    let { resourceName, resourceDescription, resourceImage, resourceId } = linkedData;
    const { t } = (0, react_2.useTranslate)();
    const prefix = 'resources';
    return (react_1.default.createElement(HCard_1.default, { name: t(prefix + '.name.' + resourceId, resourceName), description: t(prefix + '.desc.' + resourceId, resourceDescription), image: resourceImage, onClick: onClick }));
});
(0, package_1.registerPackageModule)(module);
//# sourceMappingURL=ResourceCard.js.map